<div id="disable-overlay" *ngIf="!enabled">

</div>

<div class="keypad">
  <mat-form-field color="primary" class="phone-number">
    <input #number_input [hidden]="activeCall" [disabled]="isMobileDevice()" matInput [(ngModel)]="phoneNumber"
      class="phone-input" (keyup)="handleKeyboardEvent($event)">
    
    <input #number_input [hidden]="!activeCall" matInput [(ngModel)]="typedNumber"
      class="phone-input" readonly>

    <button *ngIf="!activeCall" type="button" mat-icon-button matSuffix (tap)="delDigit()" (press)="clearNumber()">
      <mat-icon color="primary">backspace</mat-icon>
    </button>
  </mat-form-field>
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center">
      <button mat-fab (tap)="addDigit('1')" class="numpad">1</button>
      <button mat-fab (tap)="addDigit('2')" class="numpad">2</button>
      <button mat-fab (tap)="addDigit('3')" class="numpad">3</button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button mat-fab (tap)="addDigit('4')" class="numpad">4</button>
      <button mat-fab (tap)="addDigit('5')" class="numpad">5</button>
      <button mat-fab (tap)="addDigit('6')" class="numpad">6</button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button mat-fab (tap)="addDigit('7')" class="numpad">7</button>
      <button mat-fab (tap)="addDigit('8')" class="numpad">8</button>
      <button mat-fab (tap)="addDigit('9')" class="numpad">9</button>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button mat-fab (tap)="addDigit('*')" class="numpad">*</button>
      <button mat-fab (press)="addDigit('+')" (tap)="addDigit('0')" class="numpad" fxLayoutAlign="center center"
        fxLayout="column">
        <div>0</div>
        <div>+</div>
      </button>
      <button mat-fab (tap)="addDigit('#')" class="numpad">#</button>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!activeCall" class="call mt-1 text-center">
      <div fxFlex>
        <button *ngIf="phoneNumber" type="button" mat-icon-button (tap)="sendSMS()" class="bt-message">
          <mat-icon>textsms</mat-icon>
        </button>
      </div>

      <div fxFlex>
        <button type="button" mat-button mat-fab (tap)="makeCall()" class="bt-call">
          <mat-icon>phone</mat-icon>
        </button>
      </div>

      <div fxFlex></div>
    </div>
  </div>

  <!-- <div *ngIf="!activeCall" text-center style="margin: 5px 0px 0px 1px">
      <button mat-button mat-fab (tap)="makeCall()" class="bt-call">
        <mat-icon>phone</mat-icon>
      </button>
    </div> -->
</div>
